import React from 'react';
import assemblyMap from './maps/component';
import AssemblyBase from './base';

/**
 * This assembly is for the sub-page level components.
 */
const Assembly = (props) => <AssemblyBase map={assemblyMap} {...props} />;

export default Assembly;
